import {
  Box,
  FormControl,
  FormLabel,
  IconButton,
  Input,
  Heading,
  HStack,
  SimpleGrid,
} from "@chakra-ui/react";
import CodesetSelect from "../../CodesetSelect";
import UuidPreview from "../../UuidPreview";
import CurrencyAmountInput from "../../CurrencyAmountInput";
import RateAmountInput from "../../RateAmountInput";

const PremiumAdjustmentEditor = ({ premiumAdjustment = {}, onChange }) => {
  const updateField = (field, value) => {
    onChange({
      ...premiumAdjustment,
      [field]: value,
    });
  };

  return (
    <Box>
      <Heading size="md" mb={4}>
        Premium Adjustment
      </Heading>

      <Box borderWidth="1px" borderRadius="md" p={4}>
        {premiumAdjustment.id && <UuidPreview uuid={premiumAdjustment.id} />}

        <FormControl mb={4}>
          <FormLabel>Description</FormLabel>
          <Input
            value={premiumAdjustment.description || ""}
            onChange={(e) => updateField("description", e.target.value)}
          />
        </FormControl>

        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4} mb={4}>
          <FormControl>
            <FormLabel>Credit Period Duration (Days)</FormLabel>
            <Input
              type="number"
              value={premiumAdjustment.creditPeriodDurationDays || 0}
              onChange={(e) =>
                updateField("creditPeriodDurationDays", parseInt(e.target.value) || 0)
              }
            />
          </FormControl>

          <FormControl>
            <FormLabel>Premium Amount Currency Code</FormLabel>
            <Input
              value={premiumAdjustment.premiumAmountCurrencyCode || ""}
              onChange={(e) =>
                updateField("premiumAmountCurrencyCode", e.target.value)
              }
            />
          </FormControl>

          <CurrencyAmountInput
            label="Premium Amount"
            value={premiumAdjustment.premiumAmount}
            onChange={(value) => updateField("premiumAmount", value)}
          />
        </SimpleGrid>

        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4} mb={4}>
          <RateAmountInput
            label="Rate"
            value={premiumAdjustment.rate}
            onChange={(value) => updateField("rate", value)}
          />

          <RateAmountInput
            label="Minimum Rate"
            value={premiumAdjustment.minimumRate}
            onChange={(value) => updateField("minimumRate", value)}
          />

          <RateAmountInput
            label="Maximum Rate"
            value={premiumAdjustment.maximumRate}
            onChange={(value) => updateField("maximumRate", value)}
          />
        </SimpleGrid>

        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} mb={4}>
          <CodesetSelect
            label="Basis"
            codesetCode="A91"
            value={
              premiumAdjustment.basis
                ? { code: premiumAdjustment.basis, description: "" }
                : null
            }
            onChange={(value) => updateField("basis", value.code)}
          />

          <CodesetSelect
            label="Calculation Type"
            codesetCode="A92"
            value={
              premiumAdjustment.calculationType
                ? { code: premiumAdjustment.calculationType, description: "" }
                : null
            }
            onChange={(value) => updateField("calculationType", value.code)}
          />
        </SimpleGrid>

        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4} mb={4}>
          <CodesetSelect
            label="Calculation Loading Operation"
            codesetCode="A93"
            value={
              premiumAdjustment.calculationLoadingOperationCode
                ? {
                    code: premiumAdjustment.calculationLoadingOperationCode,
                    description: "",
                  }
                : null
            }
            onChange={(value) =>
              updateField("calculationLoadingOperationCode", value.code)
            }
          />

          <FormControl>
            <FormLabel>Calculation Loading Fraction Numerator</FormLabel>
            <Input
              type="number"
              value={premiumAdjustment.calculationLoadingFractionNumerator || 0}
              onChange={(e) =>
                updateField(
                  "calculationLoadingFractionNumerator",
                  parseInt(e.target.value) || 0
                )
              }
            />
          </FormControl>

          <FormControl>
            <FormLabel>Calculation Loading Fraction Denominator</FormLabel>
            <Input
              type="number"
              value={premiumAdjustment.calculationLoadingFractionDenominator || 0}
              onChange={(e) =>
                updateField(
                  "calculationLoadingFractionDenominator",
                  parseInt(e.target.value) || 0
                )
              }
            />
          </FormControl>
        </SimpleGrid>

        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4} mb={4}>
          <CodesetSelect
            label="Calculation Frequency"
            codesetCode="A94"
            value={
              premiumAdjustment.calculationFrequencyCode
                ? {
                    code: premiumAdjustment.calculationFrequencyCode,
                    description: "",
                  }
                : null
            }
            onChange={(value) =>
              updateField("calculationFrequencyCode", value.code)
            }
          />

          <FormControl>
            <FormLabel>Calculation Period Start Date/Time</FormLabel>
            <Input
              type="datetime-local"
              value={premiumAdjustment.calculationPeriodStartDateTime?.value || ""}
              onChange={(e) =>
                updateField("calculationPeriodStartDateTime", {
                  ...premiumAdjustment.calculationPeriodStartDateTime,
                  value: e.target.value,
                })
              }
            />
          </FormControl>

          <FormControl>
            <FormLabel>Calculation Period End Date/Time</FormLabel>
            <Input
              type="datetime-local"
              value={premiumAdjustment.calculationPeriodEndDateTime?.value || ""}
              onChange={(e) =>
                updateField("calculationPeriodEndDateTime", {
                  ...premiumAdjustment.calculationPeriodEndDateTime,
                  value: e.target.value,
                })
              }
            />
          </FormControl>
        </SimpleGrid>
      </Box>
    </Box>
  );
};

export default PremiumAdjustmentEditor;
